<template>
  <EventsList />
</template>

<script>
import EventsList from '@/components/content/events/EditEvents.vue'

export default {
  name: 'ContentEvents',
  components: { EventsList }
}
</script>

<style scoped>

</style>
